import React from 'react';
import type { PeekInsideSlide } from '../../data/peekInsideSlides';
type SnapTrackProps = {
  slides: PeekInsideSlide[];
  active: number;
  trackRef: React.RefObject<HTMLDivElement>;
  onScroll: () => void;
  onOpen: (index: number) => void;
};
export function SnapTrack({
  slides,
  active,
  trackRef,
  onScroll,
  onOpen
}: SnapTrackProps) {
  return <div ref={trackRef} onScroll={onScroll} className="relative flex snap-x snap-mandatory gap-4 overflow-x-auto px-[8%] py-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-id="element-182" data-mp="2wdzhn17s5474">
      {slides.map((slide, i) => <div key={slide.src} className="w-[84%] flex-none snap-center" data-id="element-183" data-mp="28ioeqy149pdv" data-mpi={i}>
          <button type="button" onClick={() => onOpen(i)} aria-label={`Open full size: ${slide.caption}`} className={`block aspect-[4/5] w-full overflow-hidden rounded-[12px] border border-gold/40 bg-plum-deep shadow-[0_20px_50px_-24px_rgba(232,170,80,0.45),0_8px_20px_-8px_rgba(0,0,0,0.7)] transition-opacity duration-200 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-plum-deep ${i === active ? 'opacity-100' : 'opacity-50'}`} data-id="element-184" data-mp="2dh83t7b0bhag">
            <img src={slide.src} alt={slide.alt} width={1560} height={1950} loading={i === active ? 'eager' : 'lazy'} draggable={false} className="h-full w-full object-contain" data-id="element-185" data-mp="gwdezk41xfs2" />
          </button>
        </div>)}
    </div>;
}